var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper presentation-page"},[_c('hero'),_c('vos-metiers'),_c('solution-arago'),_c('nos-technologies'),_c('vos-interlocuteurs'),_c('nous-contacter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }